import red from '@material-ui/core/colors/red';

import { createTheme } from '@material-ui/core/styles'

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#40906c',
    },
    secondary: {
      main: '#7de2b5',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
});

export default theme;
